/**
 * @fileoverview POST handler for the "/api/calculated_attributes/:app_group_id/archive" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postApiCalculatedAttributesAppGroupIdArchiveCacheKeys } from "./constants";
import type {
  PostApiCalculatedAttributesAppGroupIdArchiveProps,
  PostApiCalculatedAttributesAppGroupIdArchiveResult,
} from "./types";

// POST rather than the PATCH calculated filters uses -- see routes.rb.
export const postApiCalculatedAttributesAppGroupIdArchive = reactQueryMutationAdapter(
  postApiCalculatedAttributesAppGroupIdArchiveCacheKeys,
  (
    props: PostApiCalculatedAttributesAppGroupIdArchiveProps
  ): Promise<PostApiCalculatedAttributesAppGroupIdArchiveResult> => {
    const { app_group_id: appGroupId, calculated_attribute_ids: calculatedAttributeIds } = props;
    return fetch(
      `/api/calculated_attributes/${appGroupId}/archive`,
      "POST",
      { calculated_attribute_ids: calculatedAttributeIds },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
